function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Popup from '../Popup';
import DatePanel from '../DatePicker/DatePanel';
import DateHeader from '../DatePicker/DateHeader';
import { todayDateObj, getValueFromDateObj } from '../DatePicker/helper';
import { makeRangeDispalyValue, getValueFromRangeValue, fixDateRangeListSelected, fixDateRangeListHovered, getRangeDateList, comparable } from './helper';
import Icon from '../Icon';
import './style.less';

var DateRangePicker = /*#__PURE__*/function (_Component) {
  _inherits(DateRangePicker, _Component);

  var _super = _createSuper(DateRangePicker);

  function DateRangePicker(props) {
    var _this;

    _classCallCheck(this, DateRangePicker);

    _this = _super.call(this, props);
    _this.handleClickInput = _this.handleClickInput.bind(_assertThisInitialized(_this));
    _this.handleDateSelect = _this.handleDateSelect.bind(_assertThisInitialized(_this));
    _this.handleHeaderChange = _this.handleHeaderChange.bind(_assertThisInitialized(_this));
    _this.handleHover = _this.handleHover.bind(_assertThisInitialized(_this)); // this.handlePopupExpand = this.handlePopupExpand.bind(this);

    var value = props.value;
    var leftDateObj;
    var rightDateObj;
    var startDateObj;
    var endDateObj;
    var selectedValue = '开始日期 ~ 结束日期';

    if (value) {
      var valueObj = getValueFromRangeValue(value);
      leftDateObj = _objectSpread({}, valueObj.start);
      rightDateObj = _objectSpread({}, valueObj.end); // 处理起止在同一个月份的情况

      if (leftDateObj.month === rightDateObj.month && leftDateObj.year === rightDateObj.year) {
        rightDateObj.month += 1;
      }

      startDateObj = valueObj.start;
      endDateObj = valueObj.end;
      selectedValue = makeRangeDispalyValue(startDateObj, endDateObj);
    } else {
      leftDateObj = todayDateObj;
      rightDateObj = _objectSpread({}, todayDateObj, {
        month: todayDateObj.month + 1
      });
      startDateObj = null;
      endDateObj = null;
    }

    _this.state = {
      expand: false,
      leftDateList: getRangeDateList(leftDateObj, startDateObj, endDateObj),
      rightDateList: getRangeDateList(rightDateObj, startDateObj, endDateObj),
      // 左边日期选择框展示的日历月份
      leftDateObj: leftDateObj,
      // 右边日期选择框展示的日历月份
      rightDateObj: rightDateObj,
      // 展示的日期
      selectedValue: selectedValue,
      // 开始日期
      startDateObj: startDateObj,
      // 结束日期
      endDateObj: endDateObj,
      // 是否正在选择，即已经选择了开始时间但未选择结束时间
      isSelecting: false
    };
    return _this;
  }

  _createClass(DateRangePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$wrp$getBounding = this.wrp.getBoundingClientRect(),
          x = _this$wrp$getBounding.x,
          y = _this$wrp$getBounding.y,
          height = _this$wrp$getBounding.height;

      this.popupStyle = {
        left: x,
        top: y + height + 1
      };
    }
  }, {
    key: "getPopup",
    value: function getPopup(clsPrefix) {
      var _this2 = this;

      var _this$state = this.state,
          leftDateObj = _this$state.leftDateObj,
          rightDateObj = _this$state.rightDateObj,
          leftDateList = _this$state.leftDateList,
          rightDateList = _this$state.rightDateList;
      var showYearControl = leftDateObj.year < rightDateObj.year;
      var showMonthControl = leftDateObj.year < rightDateObj.year || leftDateObj.year === rightDateObj.year && leftDateObj.month + 1 < rightDateObj.month;
      return /*#__PURE__*/React.createElement(Popup, {
        hide: false,
        style: this.popupStyle,
        didMount: this.handlePopupExpand
      }, /*#__PURE__*/React.createElement("div", {
        ref: function ref(dom) {
          _this2.popup = dom;
        },
        className: "".concat(clsPrefix, "--popup")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--left")
      }, /*#__PURE__*/React.createElement(DateHeader, {
        dateObj: leftDateObj,
        onChange: function onChange(data) {
          _this2.handleHeaderChange('left', data);
        },
        showRightYearControl: showYearControl,
        showRightMonthControl: showMonthControl
      }), /*#__PURE__*/React.createElement(DatePanel, {
        onChange: this.handleDateSelect,
        dateList: leftDateList,
        onHover: this.handleHover
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--right")
      }, /*#__PURE__*/React.createElement(DateHeader, {
        dateObj: rightDateObj,
        onChange: function onChange(data) {
          _this2.handleHeaderChange('right', data);
        },
        showLeftYearControl: showYearControl,
        showLeftMonthControl: showMonthControl
      }), /*#__PURE__*/React.createElement(DatePanel, {
        onChange: this.handleDateSelect,
        dateList: rightDateList,
        onHover: this.handleHover
      }))));
    }
    /*     handlePopupExpand() {
     *         const {
     *             startDateObj,
     *             endDateObj,
     *             leftDateObj,
     *             rightDateObj,
     *         } = this.state;
     *
     *
     *         this.setState({
     *             leftDateList: getRangeDateList(leftDateObj, startDateObj, endDateObj),
     *             rightDateList: getRangeDateList(rightDateObj, startDateObj, endDateObj),
     *         });
     *     } */

  }, {
    key: "handleDateSelect",
    value: function handleDateSelect(selectedDate) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      var _this$state2 = this.state,
          isSelecting = _this$state2.isSelecting,
          startDateObj = _this$state2.startDateObj,
          leftDateList = _this$state2.leftDateList,
          rightDateList = _this$state2.rightDateList;
      var newStart;
      var newEnd;

      if (isSelecting) {
        if (comparable(startDateObj) > comparable(selectedDate)) {
          newStart = selectedDate;
          newEnd = startDateObj;
        } else {
          newStart = startDateObj;
          newEnd = selectedDate;
        }

        var newValue = makeRangeDispalyValue(newStart, newEnd); // 修改日历选中状态

        var newRightDateObj = _objectSpread({}, newEnd);

        if (newStart.month === newEnd.month && newStart.year === newEnd.year) {
          newRightDateObj.month += 1;
        }

        this.setState({
          startDateObj: newStart,
          endDateObj: newEnd,
          leftDateObj: newStart,
          rightDateObj: newRightDateObj,
          selectedValue: newValue,
          leftDateList: getRangeDateList(newStart, newStart, newEnd),
          rightDateList: getRangeDateList(newRightDateObj, newStart, newEnd),
          isSelecting: false,
          expand: false
        });
        onChange({
          value: newValue,
          start: getValueFromDateObj(newStart),
          end: getValueFromDateObj(newEnd),
          name: name
        });
      } else {
        newStart = selectedDate; // 修改日历选中状态

        var newLeftDateList = fixDateRangeListSelected(leftDateList, newStart, {});
        var newRightDateList = fixDateRangeListSelected(rightDateList, newStart, {});
        this.setState({
          startDateObj: newStart,
          endDateObj: null,
          leftDateList: newLeftDateList,
          rightDateList: newRightDateList,
          isSelecting: true
        });
      }
    }
  }, {
    key: "handleHeaderChange",
    value: function handleHeaderChange(pos, data) {
      var _this$setState;

      var _this$state3 = this.state,
          startDateObj = _this$state3.startDateObj,
          endDateObj = _this$state3.endDateObj;
      var newDateList = getRangeDateList(data, startDateObj, endDateObj);
      this.setState((_this$setState = {}, _defineProperty(_this$setState, "".concat(pos, "DateObj"), data), _defineProperty(_this$setState, "".concat(pos, "DateList"), newDateList), _this$setState));
    }
  }, {
    key: "handleClickInput",
    value: function handleClickInput() {
      var expand = this.state.expand;
      this.setState({
        expand: !expand
      });
    }
  }, {
    key: "handleHover",
    value: function handleHover(dateObj) {
      var _this$state4 = this.state,
          isSelecting = _this$state4.isSelecting,
          leftDateList = _this$state4.leftDateList,
          startDateObj = _this$state4.startDateObj,
          rightDateList = _this$state4.rightDateList;

      if (isSelecting) {
        var newLeftDateList = fixDateRangeListHovered(leftDateList, startDateObj, dateObj);
        var newRightDateList = fixDateRangeListHovered(rightDateList, startDateObj, dateObj);
        this.setState({
          leftDateList: newLeftDateList,
          rightDateList: newRightDateList
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      var clsPrefix = 'kui-date-range-picker';

      var _this$props2 = this.props,
          className = _this$props2.className,
          style = _this$props2.style,
          error = _this$props2.error,
          disabled = _this$props2.disabled,
          others = _objectWithoutProperties(_this$props2, ["className", "style", "error", "disabled"]);

      var _this$state5 = this.state,
          expand = _this$state5.expand,
          selectedValue = _this$state5.selectedValue;
      var cls = classNames(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "__error"), error), _defineProperty(_classNames, "".concat(clsPrefix, "__disabled"), disabled), _classNames), className);
      return /*#__PURE__*/React.createElement("div", _extends({}, others, {
        style: style,
        className: cls
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--display"),
        onClick: this.handleClickInput,
        ref: function ref(dom) {
          _this3.wrp = dom;
        }
      }, /*#__PURE__*/React.createElement("input", {
        className: "".concat(clsPrefix, "--input"),
        type: "text",
        name: "",
        value: selectedValue,
        readOnly: true
      }), /*#__PURE__*/React.createElement(Icon, {
        iconClass: "".concat(clsPrefix, "--icon kz-e-calendar")
      })), expand && this.getPopup(clsPrefix));
    }
  }]);

  return DateRangePicker;
}(Component);

DateRangePicker.defaultProps = {
  className: '',
  style: {},
  value: null,
  name: '',
  error: false,
  disabled: false,
  onChange: function onChange() {}
};
DateRangePicker.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  name: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
};
export default DateRangePicker;